import { Button, Filters } from "@volt_developers/components";
import { useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";

import { FILTERS_TEST_IDS } from "../../constants/TestIds";

interface ActionsProps {
  areFiltersInitialAndDefaultDifferent: boolean;
  areFiltersTheSameAsInitial: boolean;
  handleApply: VoidFunction;
  handleClose: VoidFunction;
  handleReset: VoidFunction;
  areFiltersInvalid?: boolean;
}

export function Actions({
  areFiltersTheSameAsInitial,
  areFiltersInitialAndDefaultDifferent,
  handleReset,
  handleClose,
  handleApply,
  areFiltersInvalid,
}: ActionsProps) {
  const { t } = useTranslation("common");
  const isApplyButtonInvalid = areFiltersInvalid || areFiltersTheSameAsInitial;

  return (
    <Filters.Footer data-testid={FILTERS_TEST_IDS.actions}>
      <Button
        color="ghost-blue"
        data-testid={FILTERS_TEST_IDS.resetAction}
        disabled={!areFiltersInitialAndDefaultDifferent}
        onClick={handleReset}
      >
        {t(COMMON_TRANSLATION_KEYS.reset)}
      </Button>
      <Button
        data-testid={FILTERS_TEST_IDS.cancelAction}
        sx={{ ml: "auto" }}
        variant="outlined"
        onClick={handleClose}
      >
        {t(COMMON_TRANSLATION_KEYS.close)}
      </Button>
      <Button
        data-testid={FILTERS_TEST_IDS.applyAction}
        disabled={isApplyButtonInvalid}
        onClick={handleApply}
      >
        {t(COMMON_TRANSLATION_KEYS.applyFilters)}
      </Button>
    </Filters.Footer>
  );
}
